import React, { useEffect, useRef } from "react";

/**
 * Gold dot + lagging gold ring custom cursor.
 * Disabled below 1024px (touch devices) via CSS.
 */
const CustomCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(max-width: 1024px)").matches) return;

    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let ringX = mouseX;
    let ringY = mouseY;
    let raf;

    const onMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${mouseX}px, ${mouseY}px) translate(-50%, -50%)`;
      }
    };

    const onEnter = (e) => {
      const target = e.target;
      if (
        target.closest(
          "button, a, [data-cursor-hover], input, textarea, select, label"
        )
      ) {
        ringRef.current?.classList.add("is-hover");
      }
    };
    const onLeave = (e) => {
      const target = e.target;
      if (
        target.closest(
          "button, a, [data-cursor-hover], input, textarea, select, label"
        )
      ) {
        ringRef.current?.classList.remove("is-hover");
      }
    };

    const animate = () => {
      ringX += (mouseX - ringX) * 0.18;
      ringY += (mouseY - ringY) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(animate);
    };

    window.addEventListener("mousemove", onMove);
    document.addEventListener("mouseover", onEnter);
    document.addEventListener("mouseout", onLeave);
    raf = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", onEnter);
      document.removeEventListener("mouseout", onLeave);
    };
  }, []);

  return (
    <>
      <div ref={dotRef} className="num-cursor-dot" data-testid="cursor-dot" />
      <div ref={ringRef} className="num-cursor-ring" data-testid="cursor-ring" />
    </>
  );
};

export default CustomCursor;
